
module.exports = [

{ 
  name: "pink-majesty",
  palette: 
[
  [
    217.41281720694147,
    85.71670526185191,
    234.53411426449122
  ],
  [
    190.47502366059473,
    188.27553740194318,
    217.50681518288587
  ],
]
}
,
{
  name: "atari",
  palette:
[
  [
    120.93103740051399,
    38.142581695922644,
    57.33440318888885
  ],
  [
    170.2870055208793,
    206.3232021623334,
    120.71086460718577
  ],
]
},
{
  name: "red-rain",
  palette:

[
  [
    99.81293383292255,
    112.1229011775702,
    128.7508510617224
  ],
  [
    212.49411121493665,
    32.42659769336058,
    66.91179247752444
  ]
]
},
{
  name: "roboitcs",
  palette: [
  [
    171.19380188701228,
    107.80313382885694,
    196.15441555850262
  ],
  [
    81.38242645059263,
    75.53531069867432,
    106.08746811365782
  ]
]
},
{
  name: "algea",
  palette: [
  [
    59.5543094353272,
    238.92627921976464,
    28.67955868812066
  ],
  [
    17.807658847252466,
    98.08655868403795,
    179.54935612450626
  ]
]
},
{
  name: "vagina",
  palette: [
  [
    169.45998934713342,
    173.30590990991305,
    78.89726635057714
  ],
  [
    231.8197051124283,
    72.69418165388394,
    212.53392187883836
  ]
]
},
{
  name: "couch",
  palette: [
  [
    188.21089060424816,
    74.13959056687,
    62.1790998482193
  ],
  [
    179.59669944638503,
    181.99483200744535,
    49.596651361795494
  ]
]
},
{
  name: "gamer",
  palette: [
  [
    107.00529593849089,
    245.0841793080545,
    54.33924516464678
  ],
  [
    33.389693888581085,
    8.883386351727681,
    22.801724736146905
  ]
]
},
{
  name: "stranger",
  palette: [
  [
    246.08039801047468,
    212.51717793552567,
    83.65233783468705
  ],
  [
    33.608437134261074,
    57.884440576310375,
    189.58240035887368
  ]
]
},
{
  name: "frog",
  palette: [
  [
    126.2761044379545,
    193.7503889838386,
    101.47535519097403
  ],
  [
    253.47704108328216,
    210.78144829478978,
    63.888538341757254
  ]
]
},
{
  name: "frost",
  palette: [
  [
    246.68619304578732,
    249.6008641254971,
    254.08108446333875
  ],
  [
    52.514221676128955,
    248.99402011031574,
    245.4149238772048
  ]
]
},
{
  name: "lemonade",
  palette: 
    [
      [255, 219, 36],
      [36, 220, 255]
    ]
},
{
  name: "tapestry",
  palette: 
    [
      [179, 99, 221],
      [236, 161, 28]
    ]
},
{
  name: "pistachio",
  palette: 
    [
      [110, 72, 233],
      [158, 238, 80]
    ]
},
{
  name: "hulk",
  palette: [
  [
    137.037894786498,
    242.6960679446991,
    97.98795951776864
  ],
  [
    28.53155136162383,
    116.13735473072863,
    83.33317924993347
  ]
] 
},
{
  name: "lime",
  palette: [
  [
    32.2611701718842,
    66.25579459665731,
    67.57886804570627
  ],
  [
    148.1878074765798,
    238.82677625841697,
    104.80473917774532
  ]
]
},
{
  name: "purple-mochachino",
  palette: [
  [
    148.2177211775049,
    53.84861407376081,
    162.3165293405679
  ],
  [
    243.02734121320006,
    224.0353360157385,
    174.9077998631199
  ]
]
},
{
  name: "holiday",
  palette: [
  [
    241.5617503950091,
    164.61443431426392,
    22.30614311223154
  ],
  [
    98.70244509097907,
    135.1295192515165,
    97.3825200955876
  ]
]
},{
  name: "kids",
  palette: [
  [
    101.35859627787408,
    232.4939215698514,
    224.8634862098238
  ],
  [
    253.78139622891368,
    109.66793038341056,
    155.49404857847276
  ]
]
},
{
  name: "lemonlicker",
  palette: [
  [
    198.90642003445842,
    140.00976608808094,
    143.24866266863705
  ],
  [
    219.044223156613,
    218.01614733858685,
    41.38098404306186
  ]
]
},
{
  name: "abscence",
  palette: [
  [
    252.0654624455239,
    53.84686240740819,
    34.55494604851597
  ],
  [
    91.05786933161018,
    73.66456292879593,
    100.35311189064667
  ]
]
},
{
  name: "shaveice",
  palette: [
  [
    54.37303367400141,
    16.07942214107485,
    69.63799115088366
  ],
  [
    23.823039480486653,
    227.86236285399593,
    214.28733659578742
  ]
]
},
{
  name: "gemma",
  palette: [
  [
    210.96759967087198,
    248.64083609236522,
    33.547645953438476
  ],
  [
    202.28539433891663,
    39.98961185074542,
    81.56299430370248
  ]
]
},
{
  name: "stale",
  palette: [
  [
    195.7032006141748,
    12.532767407849304,
    14.203323651336571
  ],
  [
    246.515514977768,
    201.9210316939232,
    153.53371634364328
  ]
]
},
{
  name: "core",
  palette: [
  [
    246.78300221314808,
    247.67637108514043,
    226.4970853298152
  ],
  [
    27.570132677780304,
    90.74096313530514,
    77.97408097278888
  ]
]
},
{
  name: "gum",
  palette: [
  [
    92.20310987634956,
    85.74462863386465,
    189.81765098545748
  ],
  [
    215.01727210382472,
    82.65239688678876,
    126.60106147781443
  ]
]
},
{
  name: "success",
  palette: [
  [
    238.7459786514361,
    198.71085086510828,
    62.34969717484118
  ],
  [
    226.93751673939946,
    86.41918303874503,
    47.33184534555451
  ]
]
},
{
  name: "pleasure",
  palette: [
  [
    4.250763403282502,
    59.05843191541275,
    77.95272875102464
  ],
  [
    215.57835689042727,
    13.201770589446708,
    94.41329489071516
  ]
]
},
{
  name: "lemongrass",
  palette: [
  [
    63.04044997444623,
    98.56260436640183,
    53.36684541108194
  ],
  [
    205.13172995408414,
    200.38078209004567,
    12.5831402385771
  ]
]
},
{
  name: "ram",
  palette: [
  [
    22.281265953581773,
    6.349966431572551,
    91.88588743528096
  ],
  [
    141.77968240973337,
    59.63472833171327,
    50.34950333146158
  ]
]
},
{
  name: "puppy",
  palette: [
  [
    210.20298619518394,
    104.4804322886896,
    183.2531851226219
  ],
  [
    26.200816711999916,
    227.4919098301692,
    69.35044628076422
  ]
]
},
{
  name: "juice",
  palette: [
  [
    250.2117508217491,
    108.14598556658132,
    194.93965941377002
  ],
  [
    238.7920391867524,
    237.35754315161356,
    117.92199332712417
  ]
]
},
{
  name: "mj",
  palette: [
  [
    255,
    255,
    255
  ],
  [
    0,
    0,
    0
  ]
]
},
{
  name: "brainiac",
  palette: [
  [
    90.25255547079442,
    70.52220497824011,
    59.67759720593676
  ],
  [
    18.040638769404563,
    221.40168031178342,
    169.89090354222446
  ]
]
},
{
  name: "galaxy-girl",
  palette: [
  [
    36.7370264159031,
    156.6609285810999,
    249.38407442504408
  ],
  [
    200.1939924033966,
    89.47133196385413,
    206.64731257229968
  ]
]  
},
{
  name: "jigsaw",
  palette: [
  [
    209.88046756932093,
    197.17851159311064,
    12.39825433252198
  ],
  [
    94.59457443332373,
    59.504377864502196,
    38.79828234767832
  ]
] 
},
{
  name: "lipstick",
  palette: [
  [
    210.73040690635472,
    227.82451710025344,
    5.011719506133953
  ],
  [
    196.56595186311074,
    97.0720070250516,
    171.43722268181727
  ]
]
},
{
  name: "oceanpeach",
  palette: [
  [
    240.63932628145537,
    159.90204606987197,
    151.74902126570208
  ],
  [
    71.56395839071583,
    13.729689178341943,
    253.6812540280842
  ]
] 
},
{
  name: "softness",
  palette: [
  [
    229.40826512804247,
    115.50684815892866,
    105.92233835487028
  ],
  [
    126.39153459084281,
    95.20937793362961,
    159.62717318987268
  ]
]
},{
  name: "noir",
  palette: [
    [26,26,26],
    [175,154,131]
  ]
},
{
  name: "screen",
  palette: [
    [11, 26, 35],
    [69, 165, 87]
  ]
}

]
